module.exports = {
	"_args": [
		[
			"stellar-sdk@4.0.2",
			"/Users/dawntan/Documents/GitHub/rojak/web"
		]
	],
	"_from": "stellar-sdk@4.0.2",
	"_id": "stellar-sdk@4.0.2",
	"_inBundle": false,
	"_integrity": "sha512-BGmAcxA+UoXao2IIDSN2rqJXRLGEChKxTl8C/8DJxxG8RSdO2IqB+VA+FTKaX0mFqjy7WoNlEjtJQriqEkgtYA==",
	"_location": "/stellar-sdk",
	"_phantomChildren": {
		"original": "1.0.2"
	},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "stellar-sdk@4.0.2",
		"name": "stellar-sdk",
		"escapedName": "stellar-sdk",
		"rawSpec": "4.0.2",
		"saveSpec": null,
		"fetchSpec": "4.0.2"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/stellar-sdk/-/stellar-sdk-4.0.2.tgz",
	"_spec": "4.0.2",
	"_where": "/Users/dawntan/Documents/GitHub/rojak/web",
	"author": {
		"name": "Stellar Development Foundation",
		"email": "hello@stellar.org"
	},
	"bugs": {
		"url": "https://github.com/stellar/js-stellar-sdk/issues"
	},
	"dependencies": {
		"@types/eventsource": "^1.1.2",
		"@types/node": ">= 8",
		"@types/randombytes": "^2.0.0",
		"@types/urijs": "^1.19.6",
		"axios": "^0.19.0",
		"bignumber.js": "^4.0.0",
		"detect-node": "^2.0.4",
		"es6-promise": "^4.2.4",
		"eventsource": "^1.0.7",
		"lodash": "^4.17.11",
		"randombytes": "^2.1.0",
		"stellar-base": "^2.1.4",
		"toml": "^2.3.0",
		"tslib": "^1.10.0",
		"urijs": "^1.19.1",
		"utility-types": "^3.7.0"
	},
	"description": "stellar-sdk is a library for working with the Stellar Horizon server.",
	"devDependencies": {
		"@kollavarsham/gulp-coveralls": "0.2.8",
		"@stellar/prettier-config": "^1.0.1",
		"@stellar/tsconfig": "^1.0.1",
		"@stellar/tslint-config": "^1.0.3",
		"@types/detect-node": "^2.0.0",
		"@types/lodash": "^4.14.130",
		"axios-mock-adapter": "^1.16.0",
		"babel-cli": "^6.26.0",
		"babel-core": "~6.26.3",
		"babel-eslint": "^10.0.1",
		"babel-istanbul": "^0.12.2",
		"babel-loader": "^7.0.0",
		"babel-plugin-transform-builtin-extend": "^1.1.2",
		"babel-preset-es2015": "^6.24.1",
		"babel-register": "^6.26.0",
		"body-parser": "^1.12.2",
		"chai": "^2.2.0",
		"chai-as-promised": "^5.2.0",
		"clear": "^0.1.0",
		"coveralls": "3.0.2",
		"del": "^5.1.0",
		"dtslint": "^0.6.0",
		"eslint": "^5.12.1",
		"eslint-config-airbnb-base": "^13.1.0",
		"eslint-config-prettier": "^3.6.0",
		"eslint-plugin-import": "^2.15.0",
		"eslint-plugin-node": "^8.0.1",
		"eslint-plugin-prefer-import": "^0.0.1",
		"eslint-plugin-prettier": "^3.0.1",
		"ghooks": "^0.3.0",
		"gulp": "4.0.0",
		"gulp-babel": "^6.1.3",
		"gulp-eslint": "^5.0.0",
		"gulp-insert": "^0.5.0",
		"gulp-istanbul": "^1.1.3",
		"gulp-load-plugins": "1.5.0",
		"gulp-mocha": "6.0.0",
		"gulp-plumber": "^1.0.0",
		"gulp-rename": "~1.2.0",
		"gulp-tslint": "^8.1.4",
		"husky": "^1.3.1",
		"isparta": "^4.1.1",
		"istanbul": "^0.4.5",
		"jsdoc": "3.5.5",
		"json-loader": "^0.5.1",
		"karma": "4.3.0",
		"karma-chai": "^0.1.0",
		"karma-chai-as-promised": "^0.1.2",
		"karma-chrome-launcher": "^3.1.0",
		"karma-commonjs": "^1.0.0",
		"karma-firefox-launcher": "^1.2.0",
		"karma-mocha": "1.3.0",
		"karma-phantomjs-launcher": "^1.0.4",
		"karma-sauce-launcher": "2.0.2",
		"karma-sinon": "^1.0.4",
		"karma-sinon-chai": "2.0.2",
		"karma-webpack": "3.0.5",
		"lint-staged": "7.3.0",
		"minami": "^1.1.1",
		"mocha": "5.2.0",
		"prettier": "^1.17.1",
		"sinon": "^1.14.1",
		"sinon-chai": "^2.7.0",
		"terser-webpack-plugin": "^1.3.0",
		"ts-loader": "^5.0.0",
		"tslint": "^5.16.0",
		"typescript": "^3.4.5",
		"webpack": "^4.33.0",
		"webpack-cli": "^3.3.3",
		"webpack-stream": "^5.2.1"
	},
	"homepage": "https://github.com/stellar/js-stellar-sdk",
	"husky": {
		"hooks": {
			"pre-commit": "lint-staged"
		}
	},
	"keywords": [
		"stellar"
	],
	"license": "Apache-2.0",
	"lint-staged": {
		"lib/*.{js,json}": [
			"prettier --write",
			"git add"
		],
		"lib/*.js": [
			"eslint --fix --max-warnings 0",
			"git add"
		],
		"**/*.ts": [
			"prettier --write",
			"tslint --fix",
			"git add"
		]
	},
	"main": "./lib/index.js",
	"name": "stellar-sdk",
	"prettier": "@stellar/prettier-config",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/stellar/js-stellar-sdk.git"
	},
	"scripts": {
		"build:docs": "gulp build:docs",
		"docs": "yarn build:docs && jsdoc -c .jsdoc.json",
		"dtslint": "dtslint test/types",
		"postversion": "git push && git push --tags",
		"prepare": "gulp build",
		"prettier-all": "prettier --write **/*.{js,ts}",
		"preversion": "gulp test",
		"test": "babel-node ./node_modules/.bin/gulp test",
		"version": "gulp build"
	},
	"types": "./lib/index.d.ts",
	"version": "4.0.2"
};


//////////////////
// WEBPACK FOOTER
// ./~/stellar-sdk/package.json
// module id = 195
// module chunks = 0